import { capitalize } from 'lodash';
import {
  StyledFilterLine,
  StyledFilterName,
  StyledFilterValues,
  StyledFiltersGroup
} from './CategoryFilters.style';

const formatFilterKey = filterKey => capitalize(filterKey.replace('_', ' '));

const CategoryFiltersLine = ({ filters }) => {
  const customFields = filters?.custom_fields || {};
  const reducedFilters = {
    ...filters,
    ...customFields
  };
  return (
    <StyledFilterLine>
      {Object.keys(reducedFilters).map(filterKey => {
        const filter = reducedFilters[filterKey];
        const filterValues = Array.isArray(filter.values)
          ? filter.values
          : filter;

        if (!Array.isArray(filterValues) || filterValues.length === 0)
          return null;

        const filterKeyInView = formatFilterKey(filter?.name || filterKey);

        return (
          <StyledFiltersGroup key={filterKey}>
            <StyledFilterName>{filterKeyInView}:</StyledFilterName>
            <StyledFilterValues>{filterValues.join(', ')}</StyledFilterValues>
          </StyledFiltersGroup>
        );
      })}
    </StyledFilterLine>
  );
};

export default CategoryFiltersLine;
